import { TruncateWithTooltip, toLocalDateTimeString } from 'lib';

export type GridColDef = {
    field: string;
    headerName: string;
    width?: number;
    editable?: boolean;
    flex?: number;
    headerClassName?: string;
    renderCell?: (params: TReceiptDataGridCel) => JSX.Element;
};

export const getColumns = (): GridColDef[] => {
    return [
        {
            field: 'header.timestamp',
            headerName: 'timestamp',
            editable: false,
            flex: 1,
            headerClassName: 'dictionary-grid-header',
            renderCell: (params: TReceiptDataGridCel): JSX.Element => (
                <TruncateWithTooltip
                    text={toLocalDateTimeString(params.row.header?.timestamp)}
                />
            ),
        },
        {
            field: 'contractSdoId',
            headerName: 'sdoId',
            editable: false,
            flex: 2,
            headerClassName: 'dictionary-grid-header',
            renderCell: (params: TReceiptDataGridCel): JSX.Element => (
                <TruncateWithTooltip text={`${params.row?.contractSdoId}`} />
            ),
        },
        {
            field: 'receiptSmartContract.function',
            headerName: 'function',
            editable: false,
            flex: 1,
            headerClassName: 'dictionary-grid-header',
            renderCell: (params: TReceiptDataGridCel): JSX.Element => (
                <TruncateWithTooltip
                    text={params.row.receiptSmartContract?.function}
                />
            ),
        },
        {
            field: 'receiptSmartContract.successful',
            headerName: 'successful',
            editable: false,
            flex: 1,
            headerClassName: 'dictionary-grid-header',
            renderCell: (params: TReceiptDataGridCel): JSX.Element => (
                <TruncateWithTooltip
                    text={`${params.row.receiptSmartContract?.successful}`}
                />
            ),
        },
        {
            field: 'header.owners',
            headerName: 'owners',
            editable: false,
            flex: 2,
            headerClassName: 'dictionary-grid-header',
            renderCell: (params: TReceiptDataGridCel): JSX.Element => (
                <TruncateWithTooltip text={params.row.header?.owners} />
            ),
        },
    ];
};
export const getConsentContractColumns = (): GridColDef[] => {
    return [
        {
            field: 'header.timestamp',
            headerName: 'timestamp',
            editable: false,
            flex: 2,
            headerClassName: 'dictionary-grid-header',
            renderCell: (params: TReceiptDataGridCel): JSX.Element => (
                <TruncateWithTooltip text={params.row.header?.timestamp} />
            ),
        },

        {
            field: 'contractSdoId',
            headerName: 'sdoId',
            editable: false,
            flex: 3,
            headerClassName: 'dictionary-grid-header',
            renderCell: (params: TReceiptDataGridCel): JSX.Element => (
                <TruncateWithTooltip text={params.row?.contractSdoId} />
            ),
        },
        {
            field: 'contracteffectiveId',
            headerName: 'effectiveId',
            editable: false,
            flex: 3,
            headerClassName: 'dictionary-grid-header',
            renderCell: (params: TReceiptDataGridCel): JSX.Element => (
                <TruncateWithTooltip text={params.row?.effectiveId} />
            ),
        },
        {
            field: 'contractloggedInId',
            headerName: 'loggedInId',
            editable: false,
            flex: 3,
            headerClassName: 'dictionary-grid-header',
            renderCell: (params: TReceiptDataGridCel): JSX.Element => (
                <TruncateWithTooltip text={params.row?.loggedInId} />
            ),
        },
    ];
};

export type TTReceiptDataGridCelHeader = {
    id: string;
    timestamp: string;
    hash: string;
    type: string;
    operation: string;
    owners: string[];
    signer: string;
    signature: string;
    dictionary: string;
};
export type TTReceiptDataGridCelSC = {
    function: string;
    successful: boolean;
    console: string;
};
export type TReceiptDataGridCel = {
    row: {
        header: TTReceiptDataGridCelHeader;
        contractSdoId: string;
        effectiveId: string;
        loggedInId: string;
        receiptSmartContract: TTReceiptDataGridCelSC;
    };
};
